import { SearchTerm } from "./SearchTerm";

const CardsNotUsedReportSearch: SearchTerm[] = [
    {
        heading: "All",
        accessor: "search",
        searchOnName: "search",
        translationKey: "all",
    },
    {
        heading: "Title",
        accessor: "title",
        searchOnName: "mstTitle",
        translationKey: "title",
    },
    {
        heading: "Display Name",
        accessor: "displayName",
        searchOnName: "mstDisplayname",
        translationKey: "displayName",
    },
    {
        heading: "First Name",
        accessor: "firstName",
        searchOnName: "mstFirstname",
        translationKey: "firstName",
    },
    {
        heading: "Second Name",
        accessor: "middleName",
        searchOnName: "mstMiddlename",
        translationKey: "secondName",
    },
    {
        heading: "Last Name",
        accessor: "lastName",
        searchOnName: "mstLastname",
        translationKey: "lastName",
    },
    {
        heading: "Suffix",
        accessor: "suffix",
        searchOnName: "mstSuffix",
        translationKey: "suffix",
    },
    {
        heading: "Unique Identifier",
        accessor: "idNumber",
        searchOnName: "mstIdnumber",
        translationKey: "uniqueIdentifier",
    },
];

export default CardsNotUsedReportSearch;